<script>
export default {
  props: {
    componentData: {
      default: [],
    },
  },
  data() {
    return {
      isToggled: false,
    }
  },
}
</script>

<template>
  <div>
    <b-card-header header-tag="header" class="header" role="tab">
      <b-button @click="arrowToggle()" block v-b-toggle.check-documets class="w-100 button">
        <div class="inlineButton">
          <div class="buttonTitle">
            {{ componentData.title }}
          </div>
          <div>
            <i :class="{ down: isToggled, up: !isToggled }"> </i>
          </div>
        </div>
      </b-button>
    </b-card-header>
    <b-collapse id="check-documets" visible accordion="my-checkdocumets" role="tabpanel">
      <b-card-body>
        <b-row class="mt-4">
          <b-col lg="6">
            <div class="dataDiv">
              <img class="img-fluid image-style" :src="componentData.image" />
              <div class="details">
                <span>{{componentData.imageTitle}}</span>
                <span>{{componentData.imageSize}}</span>
              </div>
            </div>
          </b-col>
          <b-col lg="6">
            <div class="dataDiv">
              <video class="w-100 borderRdius" controls>
                <source :src="componentData.video" type="video/mp4" />
              </video>
              <div class="details">
                <span>{{componentData.videoTitle}}</span>
                <span>{{componentData.videoSize}}</span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<style lang="scss" scoped>
.header {
  padding: 0;
  border: none;
  background: #f0f1f1;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  border-radius: 5px;
  width: 100%;
}
.button {
  padding: 11px 20px;
  box-shadow: none;
  border: none;
  background: #f0f1f1;
}
.image-style {
  border-radius: 7px;
  width: 530px;
}
::v-deep .collapsed {
  outline: none;
  border: none;
  background: #fafafa;
}
.dataDiv {
  border-radius: 5px;
  background: #fafafa;
  height: 100%;
}
.details {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  border-radius: 5px;
  width: 100%;
  height: 70px;
}
.buttonTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.collapse {
  border: 1px solid #f0f1f1;
  border-radius: 5px;
}
.inlineButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
i {
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
</style>
